module.exports = __webpack_public_path__ + "static/media/Emml.891b0813.jpg";